<br>
<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Gestión Tipo Motivo</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="tipoMotivoGroup" (ngSubmit)="procesoTipoMotivo();">
    <div class="row">
      <div class="col s3 m3 l3"></div>
      <div class="col s6 m6 l6">
        <mat-form-field>
          <input matInput formControlName="formDescripcion" placeholder="Descripción">
        </mat-form-field>
      </div>
      <div class="col s3 m3 l3"></div>
    </div>
    <div class="row">
      <div class="col s3 m3 l3"></div>
      <div class="col s6 m6 l6" style="text-align: center;">
        <button *ngIf="!isEdit" type="submit" [disabled]="!tipoMotivoGroup.valid || loading" mat-raised-button color="primary">Crear</button>
        <button *ngIf="isEdit" type="submit" [disabled]="!tipoMotivoGroup.valid || loading" mat-raised-button color="accent">Editar</button>&nbsp;&nbsp;
        <button *ngIf="isEdit" type="button" (click)="cancelarEdit();" mat-raised-button color="warn">Cancelar</button>
      </div>
      <div class="col s3 m3 l3"></div>
    </div>
  </form>
</mat-expansion-panel>

<br>

<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Listado Tipos Motivos</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="row">
    <div class="col s3 m3 l3"></div>
    <div class="col s6 m6 l6">
      <div class="contenedor-form" *ngIf="loading">
        <mat-spinner [diameter]="100" style="margin:0 auto; top:15px;"></mat-spinner>
      </div>
      <table [hidden]="!haveData" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display"
        style="width:100%">
        <thead>
          <tr>
            <th style="text-align: center;">Item</th>
            <th style="text-align: center;">Descripción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tiposMotivo">
            <td style="text-align: center;">
              <mat-icon style="color: gray; cursor: pointer;" (click)="editar(item);" matTooltip="Editar" matTooltipPosition="above">edit
              </mat-icon>&nbsp;&nbsp;&nbsp;
              <mat-icon style="color: red; cursor: pointer;" (click)="eliminar(item);" matTooltip="Eliminar" matTooltipPosition="above">delete
              </mat-icon>
            </td>
            <td style="text-align: left;">{{item.valor}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col s3 m3 l3"></div>
  </div>

</mat-expansion-panel>